import { BAR, FUNNEL, PIE } from "src/components/Charts/types";
import { formatSimpleChartData } from "src/sections/GroupCards/SimpleChartCard/formatData";
import { ChartManager } from "..";
import { recalcResolver } from "./recalc";

/**
 * Classe gerenciadora dos gráficos simples
 */
export class SimpleChartManager extends ChartManager {
  constructor(instance) {
    super(instance);
  }

  // Recupera o percentual total dos dados consumidos pelo gráfico
  _getTotalPercent() {
    const { data } = this.getComponentProps();
    const percentualValues = data.map(({ resultado_percentual }) => resultado_percentual);
    
    return Math.round(percentualValues.reduce((prev, current) => prev + current, 0));
  }

  // Formatador de dados: Aplica as regras de recálculo de porcentagens e formatação
  // geral de percentuais fracionários
  formatData(data) {
    const disabledLegends = this.getDisabledLegends();
    const chartType = this.getChartType();

    const totalPercent = this._getTotalPercent();
    if ([BAR, PIE, FUNNEL].includes(chartType)) {
      let newDataWithRecalc;
      if (totalPercent > 100) {
        newDataWithRecalc = recalcResolver(chartType, data, disabledLegends, false);
        return newDataWithRecalc;
      } else {
        newDataWithRecalc = formatSimpleChartData(recalcResolver(chartType, data, disabledLegends, true));

        return newDataWithRecalc;
      }
    }

    return formatSimpleChartData(data);
  }

  isBarChart() {
    return this.getChartType() === BAR;
  }

  isPieChart() {
    return this.getChartType() === PIE;
  }

  isFunnelChart() {
    return this.getChartType() === FUNNEL;
  }

  /** Resolve a lógica de resizing do gráfico, no momento somente
   * o gráfico de barras simples possui lógica de resizing
  */
  onResize(chartSizes) {
    const sizes = {
      width: chartSizes.newWidth,
      height: chartSizes.newHeight,
    };

    this.updateProps(null, null, null, null, sizes);
    this.setUpdateOnly({ resizing: true });
    this._handleEchartsUpdates(true);
  }
}